export const QuestFormSectionDivider = ({ title }: { title: string }) => {
    return (
        <>
            <h2 className="text-lg font-bold mt-2">{title}</h2>
            <hr className="-mt-4" />
        </>
    );
};